import { AxiosInstance, AxiosResponse, AxiosRequestConfig } from 'axios';
import { inject, computed, ref, reactive } from 'vue';
import qs from 'qs';

// ��Џ��API�x�[�XURI
const resource = '/companies';

/**
 * �}�X�^API�ďo���N���X
 */
export default class CompanyRepository {

    constructor(private repository: AxiosInstance) { }

    /**
     * ������Џ��擾
     * @return ������Џ��
     */
    public async getCompanyInfos(): Promise<CompanyType.CompanyInfo> {

        // API�ďo��
        const response = await this.repository.get<CompanyType.CompanyInfo>(`${resource}`);
        return response.data;
    }

    /**
     * ������Џ��X�V
     * 
     */
    public async updateCompanyInfo(compdata: CompanyType.CompUpdateInfo): Promise<boolean> {

        const apiParams = {
            zipCode: compdata.zipCode,
            prefecture: compdata.prefecture,
            cityName: compdata.cityName,
            address1: compdata.address1,
            address2: compdata.address2,
            telNo: compdata.telNo,
            faxNo: compdata.faxNo,
            rowVersion:compdata.rowVersion
        };

        // API�ďo��
        const response = await this.repository.patch<number>(`${resource}`, apiParams);
        return true;
    }

    /**
     * �����̒ʒm����擾
     * @return ������Џ�񃊃X�g
     */
    public async getNotices(): Promise<CompanyType.NotifyInfo2[]> {
        // API�ďo��
        const response = await this.repository.get<CompanyType.NotifyInfo2[]>(`${resource}/notices`);
        return response.data;
    }

    /**
     * �����̒ʒm����o�^
     * @return ����
     */
    public async addNotices(smsOrMail: string, notifyType: number, authCode: string): Promise<boolean> {
        // �p�����[�^�ݒ�
        const apiParams = { smsOrMail, notifyType, authCode };
        // API�ďo��
        await this.repository.post<CompanyType.NotifyInfo2[]>(`${resource}/notices`, apiParams);
        return true;
    }

    /**
     * �����̒ʒm����폜
     * @return ����
     */
    public async removeNotices(notifyId: number): Promise<boolean> {
        // API�ďo��
        await this.repository.delete<void>(`${resource}/notices/` + notifyId.toString());
        return true;
    }

    /**
     * �������擾
     * 
     */
    public async getHistoryInfos(param: CompanyType.HistoryParam): Promise<CompanyType.HistoryPagenate> {
        // �p�����[�^�ݒ�
        const apiParams: AxiosRequestConfig = {
            params: param,
            paramsSerializer: (params) => {
                return qs.stringify(params, { arrayFormat: 'repeat' })
            }
        };

        // API�ďo��
        const response = await this.repository.get<CompanyType.HistoryPagenate>(`${resource}/history-info`, apiParams);
        return response.data;
    }
}